import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
export class ChargeAuthorization {
    /**
     * @param id Identifies the charge authorization
     * @param authorizedAt When this charge authorization occurred
     * @param isActive Whether this charge authorization is currently active
     */
    constructor(id, authorizedAt, isActive) {
        this.id = id;
        this.isActive = isActive;
        this.authorizedAt = authorizedAt;
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * @param id Identifies the charge authorization
     * @param authorizedAt When this charge authorization occurred
     * @param isActive Whether this charge authorization is currently active
     */
    )
], ChargeAuthorization.prototype, "authorizedAt", void 0);
